import { connect } from 'react-redux';

import MessageContent from './MessageContent';


const mapStateToProps = state => {
  return ({
    users: state.users,
  })
};

export default connect(mapStateToProps)(MessageContent);
